import { GetLockerOutput } from './locker-api.types';

export class Locker {
  constructor(public getLockerOutput: GetLockerOutput) {}

  static fromResultArray(lockersOutput: GetLockerOutput[]): Locker[] {
    return lockersOutput.map((lockerOutput) => new Locker(lockerOutput));
  }

  get id() {
    return this.getLockerOutput.id;
  }

  get bezeichnung() {
    return this.getLockerOutput.bezeichnung;
  }

  get standort() {
    switch (this.getLockerOutput.standort) {
      case 1: {
        return 'B835';
      }
      case 2: {
        return 'B836';
      }
      case 3: {
        return 'B845';
      }
      default: {
        return 'Gebäude unbekannt';
      }
    }
  }

  get rawStandort() {
    return this.getLockerOutput.standort;
  }

  get geschlecht() {
    switch (this.getLockerOutput.geschlecht) {
      case 1: {
        return 'Männlich';
      }
      case 2: {
        return 'Weiblich';
      }
      case 3: {
        return 'Divers';
      }
      default: {
        return 'Unbekannt';
      }
    }
  }

  get spindart() {
    switch (this.getLockerOutput.spindart) {
      case 1: {
        return 'Schmal (300mm)';
      }
      case 2: {
        return 'Breit (400mm)';
      }
      case 3: {
        return 'Doppelspind';
      }
      case 4: {
        return 'Kleiderfach';
      }
      case 5: {
        return 'Helmfach';
      }
      case 6: {
        return 'Sammelspind';
      }
      default: {
        return 'Unbekannt';
      }
    }
  }

  get rawSpindart() {
    return this.getLockerOutput.spindart;
  }

  get status() {
    switch (this.getLockerOutput.status) {
      case 1: {
        return 'Frei';
      }
      case 2: {
        return 'Belegt';
      }
      case 3: {
        return 'Gesperrt';
      }
      default: {
        return 'Unbekannt';
      }
    }
  }

  get sperrgrund() {
    switch (this.getLockerOutput.sperrgrund) {
      case 1: {
        return 'Beschädigt';
      }
      case 2: {
        return 'Verschmutzt';
      }
      case 3: {
        return 'Schloss fehlt';
      }
      case 4: {
        return 'Schlüssel fehlt';
      }
      case 5: {
        return 'Sonstiger Sperrgrund';
      }
      default: {
        return 'Unbekannt';
      }
    }
  }

  get person() {
    return this.getLockerOutput.person;
  }

  get schluesselAusgebenAm() {
    return this.getLockerOutput.schluessel_ausgegeben_am;
  }

  get zweitschluesselAusgegebenAm() {
    return this.getLockerOutput.zweitschluessel_ausgegeben_am;
  }

  get bemerkung() {
    return this.getLockerOutput.bemerkung;
  }

  get sperrkennzeichen() {
    switch (this.getLockerOutput.sperrkennzeichen) {
      case 1: {
        return 'Spind vorhanden';
      }
      case 2: {
        return 'Spind nicht mehr vorhanden';
      }
      default: {
        return 'Unbekannt';
      }
    }
  }

  get zugewiesenAn() {
    return this.getLockerOutput.zugewiesen_an;
  }
}
